import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// 全局注册 ScrollTrigger 插件
gsap.registerPlugin(ScrollTrigger);

// 导出 gsap 和 ScrollTrigger，以便在其他文件中使用
export { gsap, ScrollTrigger };